"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosInterceptor = exports.axiosErrorCollector = exports.axiosSuccessCollector = exports.fetchInterceptor = exports.applyFetchCollector = exports.useInterceptors = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var provider_1 = require("../provider");
var react_1 = require("react");
var scenarios_1 = require("../scenarios");
var lodash_1 = require("lodash");
var decider_1 = require("../error-components/decider");
var utils_1 = require("./utils");
var windowFetch = window.fetch;
function setStateInInterceptor(newProps) {
    return function (prev) { return (__assign(__assign({}, prev), newProps)); };
}
var useInterceptors = function (setGracefulProps, config) {
    var _a = config || {}, _b = _a.urlList, urlList = _b === void 0 ? [] : _b, _c = _a.axios, axios = _c === void 0 ? null : _c;
    var _d = (0, react_1.useState)(provider_1.initialContextProps), ctx = _d[0], setContext = _d[1];
    var f = (0, exports.fetchInterceptor)({
        setGracefulContext: setContext,
        urlList: urlList,
    });
    var a = (0, exports.axiosInterceptor)(setContext, axios, urlList);
    (0, react_1.useEffect)(function () {
        return function () {
            window.fetch = f;
            a && (axios === null || axios === void 0 ? void 0 : axios.interceptors.response.eject(a));
        };
    }, [urlList, axios, a, f]);
    var errorInfoKey = (0, react_1.useCallback)(function (ctx) {
        return (0, utils_1.createErrorInfoKey)(__assign({}, (0, lodash_1.pick)(ctx, 'requestBody', 'method', 'url')));
    }, []);
    var createErrorInfo = (0, react_1.useCallback)(function (prevProps, currentCtx) {
        var isError = currentCtx.isError, status = currentCtx.status;
        if (!isError) {
            return prevProps.errorInfo;
        }
        var key = errorInfoKey(currentCtx);
        var errorInfoValue = __assign(__assign({}, ctx.ctx), { errorComponent: ((0, jsx_runtime_1.jsx)(decider_1.SelectErrorComponentWithStatusCode, __assign({}, {
                errorProps: currentCtx,
                status: status,
                userComponentMap: prevProps === null || prevProps === void 0 ? void 0 : prevProps.errorComponentMap,
                DefaultErrorComponent: prevProps === null || prevProps === void 0 ? void 0 : prevProps.DefaultErrorComponent,
            }))) });
        return prevProps.errorInfo.set(key, errorInfoValue);
    }, [ctx.ctx, errorInfoKey]);
    (0, react_1.useEffect)(function () {
        setGracefulProps(function (prev) { return (__assign(__assign(__assign({}, prev), ctx), { errorInfo: createErrorInfo(prev, ctx.ctx) })); });
    }, [ctx, createErrorInfo, setGracefulProps]);
};
exports.useInterceptors = useInterceptors;
var applyFetchCollector = function (_a) {
    var setGracefulContext = _a.setGracefulContext, urlList = _a.urlList, res = _a.res, options = _a.options;
    return __awaiter(void 0, void 0, void 0, function () {
        var clonedRes, ctx;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (urlList.length && !urlList.includes(res.url)) {
                        return [2 /*return*/, res];
                    }
                    clonedRes = res.clone ? res.clone() : (0, lodash_1.cloneDeep)(res);
                    if (!clonedRes) {
                        setGracefulContext({
                            ctx: __assign(__assign({}, provider_1.initialContextProps.ctx), { isError: true, requestBody: options }),
                        });
                        return [2 /*return*/, res];
                    }
                    return [4 /*yield*/, (0, scenarios_1.createGracefulPropsWithFetch)(clonedRes, options)];
                case 1:
                    ctx = _b.sent();
                    setGracefulContext(setStateInInterceptor({
                        ctx: ctx,
                    }));
                    return [2 /*return*/, res];
            }
        });
    });
};
exports.applyFetchCollector = applyFetchCollector;
var fetchInterceptor = function (fetchCollector) {
    return (window.fetch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var options, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = args[1];
                        return [4 /*yield*/, windowFetch.apply(void 0, args)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, (0, exports.applyFetchCollector)(__assign(__assign({}, fetchCollector), { options: options, res: res }))];
                }
            });
        });
    });
};
exports.fetchInterceptor = fetchInterceptor;
var axiosSuccessCollector = function (setGracefulContext, urlList) {
    return function (res) { return __awaiter(void 0, void 0, void 0, function () {
        var ctx;
        return __generator(this, function (_a) {
            ctx = (0, scenarios_1.createGracefulPropsWithAxios)(res);
            if (urlList.length && !urlList.includes(ctx.url)) {
                return [2 /*return*/, res];
            }
            setGracefulContext(setStateInInterceptor({ ctx: ctx }));
            return [2 /*return*/, res];
        });
    }); };
};
exports.axiosSuccessCollector = axiosSuccessCollector;
var axiosErrorCollector = function (setContext, urlList) {
    return function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var response, config, status, ctx;
        return __generator(this, function (_a) {
            response = error.response, config = error.config, status = error.status;
            if (!response) {
                setContext(setStateInInterceptor({
                    ctx: __assign(__assign({}, provider_1.initialContextProps.ctx), { method: (config === null || config === void 0 ? void 0 : config.method) || '', isError: true, status: status || 404, requestBody: config === null || config === void 0 ? void 0 : config.data }),
                }));
                return [2 /*return*/, Promise.reject(error)];
            }
            ctx = (0, scenarios_1.createGracefulPropsWithAxios)(response);
            if (urlList.length && !urlList.includes(ctx.url)) {
                return [2 /*return*/, Promise.reject(error)];
            }
            setContext(setStateInInterceptor({
                ctx: ctx,
            }));
            return [2 /*return*/, Promise.reject(error)];
        });
    }); };
};
exports.axiosErrorCollector = axiosErrorCollector;
var axiosInterceptor = function (setGracefulContext, axios, urlList) {
    if (urlList === void 0) { urlList = []; }
    if (!axios)
        return;
    return axios.interceptors.response.use((0, exports.axiosSuccessCollector)(setGracefulContext, urlList), (0, exports.axiosErrorCollector)(setGracefulContext, urlList));
};
exports.axiosInterceptor = axiosInterceptor;
